import aboutBlockFragment from "@groq/fragments/pageBlock";

const aboutBlockQuery = `*[_type == "aboutBlock"]| order(title asc)
${aboutBlockFragment}
`;

export default aboutBlockQuery;
